import { formateDate } from '@/utils/date';

export default class ClientSaleOrders {
    constructor(
        public invoiceSerie: string,
        public invoiceEmission: string,
        public order: string,
        public orderInclusionDate: string,
        public channel: string,
        public status: string,
        public value: number,
    ) {}

    public static make(data: any): ClientSaleOrders {
        let statusText = '';

        switch (data.status) {
            case '00': statusText = 'Gerado'; break;
            case '05': statusText = 'Em Análise'; break;
            case '10': statusText = 'Pagamento Confirmado'; break;
            case '15': statusText = 'Embalado'; break;
            case '21': statusText = 'Parcialmente Enviado'; break;
            case '30': statusText = 'Enviado'; break;
            case '90': statusText = 'Cancelado'; break;
            case '91': statusText = 'Devolvido'; break;
            default: statusText = 'Sem Status';
        }

        return new ClientSaleOrders(
            `${data.invoice}/${data.serie}`,
            formateDate(data.invoiceEmission),
            data.number,
            formateDate(data.orderInclusionDate),
            data.origin,
            statusText,
            data.total,
        );
    }
}
